import { render, staticRenderFns } from "./ManagerDocuments.vue?vue&type=template&id=cd660e02&"
import script from "./ManagerDocuments.vue?vue&type=script&lang=js&"
export * from "./ManagerDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports